import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["name", "viewBox", "path", "paths", "children", "title"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from "react";
import memoize from "@emotion/memoize";
import { props } from "@styled-system/should-forward-prop";
import { color, compose, css, focusOutlineProp, hoverColorProp, layout, space, styled, theme } from "@catchoftheday/theme";
import { jsx as ___EmotionJSX } from "@emotion/react";
var defaultViewBox = "0 0 34 30";
var StyledSVG = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  shape-rendering: inherit;\n"])));
var BaseIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var name = _ref.name,
      viewBox = _ref.viewBox,
      path = _ref.path,
      paths = _ref.paths,
      children = _ref.children,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(StyledSVG, _extends({
    viewBox: viewBox || defaultViewBox,
    fill: "currentcolor",
    ref: ref
  }, props), title && ___EmotionJSX("title", null, title), paths && paths.length ? paths.map(function (path, idx) {
    return ___EmotionJSX("path", _extends({
      key: "".concat(name, "-path-").concat(idx),
      d: path.d
    }, path.props));
  }) : ___EmotionJSX(React.Fragment, null, path && ___EmotionJSX("path", {
    d: path
  })), Array.isArray(children) ? children.map(function (child, idx) {
    return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
      key: "".concat(name, "-path-").concat(idx)
    }) : child;
  }) : children);
});
BaseIcon.displayName = "BaseIcon";
var styleProps = compose(layout, space, color);
export var Icon = styled(BaseIcon, {
  shouldForwardProp: memoize(function (prop) {
    return !new RegExp("^(".concat(props.join("|"), ")$")).test(prop);
  })
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  outline: 0;\n\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.hoverColor && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      :hover {\n        ", "\n      }\n    "])), hoverColorProp(props));
}, function (props) {
  return props.focusOutline && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      &:focus[data-focus-visible-added],\n      &:focus-visible {\n        ", ";\n        outline-offset: 4px;\n      }\n    "])), focusOutlineProp(props));
}, styleProps);
Icon.displayName = "Icon";
Icon.defaultProps = {
  height: "24px",
  width: "24px",
  focusOutline: "1px solid ".concat(theme.colors.secondary)
};
export function createSvgIconComponent(options) {
  var Component = function Component(props) {
    return ___EmotionJSX(Icon, _extends({}, options, props));
  };

  Component.displayName = "Icon";
  return Component;
}